import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Reports/Reports/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class ReportsQueries extends VueCqrs
{
	runReportsPageQueryV1(workspaceId: number, projectId: number)
	{
		const query = q.buildReportsPageQueryV1(workspaceId, projectId);
		this.$query(query);
	}

	runReportQueryV1(workspaceId: number, reportId: string)
	{
		const query = q.buildReportQueryV1(workspaceId, reportId);
		this.$query(query);
	}

	runPortfolioBalancerReportPageQueryV1(workspaceId: number, projectId: number, reportId: string)
	{
		const query = q.buildPortfolioBalancerReportPageQueryV1(workspaceId, projectId, reportId);
		this.$query(query);
	}
}